import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getAssetsFileUrl } from '~/utils/assetsHelper';
import { faSignOut, faEllipsis, faClock, faSearch, faDatabase, faUserShield, faUser } from "@fortawesome/free-solid-svg-icons";
import { faBell as faBellRegular } from "@fortawesome/free-regular-svg-icons";
import { Sun, Moon } from 'lucide-react';
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useUserAvatar } from '~/contexts/UserAvatarContext';
import { useAuth } from '~/contexts/AuthContext';
import axios from "axios";
import DashboardAPI from '~/api/dashboardApi';
import { faShieldAlt } from "@fortawesome/free-solid-svg-icons";
import SecuritySettingsModal from '~/components/SecuritySettingsModal';
import SearchSettingsModal from '~/components/SearchSettingsModal';
import GlobalSearchModal from '~/components/GlobalSearchModal';
import DatabaseManagementModal from '~/components/DatabaseManagementModal';
import SystemServicesTestingModal from '~/components/SystemServicesTestingModal';
import CreateAdminModal from '~/components/CreateAdminModal';
import CreateUserAccountModal from "~/components/CreateUserAccountModal";
import RoleManagementModal from '~/components/RoleManagementModal';
import ViewPermissionModal from '~/components/ViewPermissionModal';
import RequestPermissionModal from '~/components/RequestPermissionModal';
import { faHeartbeat, faUserLock, faIdBadge, faHandHoldingHand, faKey } from "@fortawesome/free-solid-svg-icons";
import PermissionGuard from '~/components/PermissionGuard';
import { ChangePasswordAdminModal } from '~/components';

const apiUrl = process.env.REACT_APP_API_URL;
function HeaderAdmin() {
    const { userAvatar } = useUserAvatar();
    const { admin } = useAuth();
    const [theme, setTheme] = useState("light");
    const logo = getAssetsFileUrl('logo', 'app-logo.png');

    const isSuperAdmin = (() => {
        if (!admin) return false;
        const roles = admin.Roles || admin.roles || [];
        const roleString = admin.Role || admin.role || '';
        return roleString === 'Super Admin' || (Array.isArray(roles) && roles.includes('Super Admin'));
    })();

    const [showSecurityModal, setShowSecurityModal] = useState(false);
    const [showSearchModal, setShowSearchModal] = useState(false);
    const [showGlobalSearch, setShowGlobalSearch] = useState(false);
    const [showDatabaseModal, setShowDatabaseModal] = useState(false);
    const [showSystemTestingModal, setShowSystemTestingModal] = useState(false);
    const [showCreateAdminModal, setShowCreateAdminModal] = useState(false);
    const [showCreateUserModal, setShowCreateUserModal] = useState(false);
    const [showRoleManagementModal, setShowRoleManagementModal] = useState(false);
    const [showMyPermissionsModal, setShowMyPermissionsModal] = useState(false);
    const [showRequestPermissionModal, setShowRequestPermissionModal] = useState(false);
    const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
    
    // XÓA BỎ DASHBOARD STATS FETCHING ĐỂ TỐI ƯU HIỆU NĂNG

    useEffect(() => {
        const html = document.documentElement;
        html.setAttribute("data-bs-theme", theme);
    })

    useEffect(() => {
        const handleKeyDown = (e) => {
            if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
                e.preventDefault();
                setShowGlobalSearch(true);
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);
    const navigate = useNavigate();
    const handleSignOut = (e) => {
        e.preventDefault();
        axios.post(`${apiUrl}/api/auth/admin-sign-out`, {}, {
            withCredentials: true
        })
            .then((res) => {
                if (res.data?.Succeeded) {
                    navigate("/auth/admin-signin", { replace: true });
                }
            })
            .catch((err) => {
                ;
            })
    }

    const getInitials = (name) => {
        if (!name) return "AD";
        return name.substring(0, 2).toUpperCase();
    };

    const renderAvatar = (sizeClass, sizePx, fontSize) => {
        const size = parseInt(sizePx);
        const badgeSize = Math.round(size * 0.45);
        const badgeFontSize = Math.round(size * 0.18);
        
        return (
            <div className={`avatar ${sizeClass}`} style={{ position: 'relative', width: sizePx, height: sizePx }}>
                <img 
                    className="rounded-circle" 
                    src="/images/admin-avatar.png" 
                    alt="" 
                    style={{ 
                        width: sizePx, 
                        height: sizePx, 
                        objectFit: 'cover',
                        border: '2px solid #e0e7ef',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.12)'
                    }} 
                />
                <div 
                    className="d-flex align-items-center justify-content-center"
                    style={{
                        position: 'absolute',
                        bottom: '-2px',
                        right: '-2px',
                        width: `${badgeSize}px`,
                        height: `${badgeSize}px`,
                        borderRadius: '50%',
                        background: 'linear-gradient(135deg, #1a73e8 0%, #6c3bdb 100%)',
                        color: '#fff',
                        fontSize: `${badgeFontSize}px`,
                        fontWeight: 800,
                        letterSpacing: '0.5px',
                        border: '2px solid #fff',
                        boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
                    }}
                >
                    {getInitials(userAvatar.UserName)}
                </div>
            </div>
        );
    };

    return (
        <nav className="navbar navbar-top fixed-top navbar-expand" id="navbarDefault">
            <div className="collapse navbar-collapse justify-content-between">
                <div className="navbar-logo">
                    <button className="btn navbar-toggler navbar-toggler-humburger-icon hover-bg-transparent"
                        type="button" data-bs-toggle="collapse" data-bs-target="#navbarVerticalCollapse"
                        aria-controls="navbarVerticalCollapse" aria-expanded="false" aria-label="Toggle Navigation">
                        <span className="navbar-toggle-icon"><span className="toggle-line"></span></span>
                    </button>
                    <Link className="navbar-brand me-1 me-sm-3" to="/ai-chatbot/administrator">
                        {
                            logo &&
                            <img src={logo} alt="bt" width="50" />
                        }
                    </Link>
                </div>

                {/* Search Bar / Ctrl+K hint */}
                {isSuperAdmin && (
                    <div className="d-none d-lg-block me-auto ms-4">
                        <button 
                            className="btn btn-light rounded-pill border d-flex align-items-center bg-white" 
                            style={{ width: '250px', padding: '6px 16px', color: '#6c757d' }}
                            onClick={() => setShowGlobalSearch(true)}
                        >
                            <FontAwesomeIcon icon={faSearch} className="me-2" />
                            <span className="me-auto fs-9">Search anything...</span>
                            <span className="badge bg-light border text-body-secondary ms-2" style={{ fontSize: '10px' }}>Ctrl + K</span>
                        </button>
                    </div>
                )}

                {/* Center Content Area */}
                <div className="d-none d-xl-flex gap-3 align-items-center justify-content-center px-4" style={{ flex: 1 }}>
                </div>

                <ul className="navbar-nav navbar-nav-icons flex-row align-items-center gap-2">
                    <li className="nav-item dropdown">
                        <a className="nav-link lh-1 pe-0" id="navbarDropdownUser" href="#!"
                            role="button" data-bs-toggle="dropdown"
                            data-bs-auto-close="outside" aria-haspopup="true"
                            aria-expanded="false">
                            {renderAvatar("avatar-l", "48px", "15px")}
                        </a>
                        <div
                            className="dropdown-menu dropdown-menu-end navbar-dropdown-caret py-0 dropdown-profile shadow border"
                            aria-labelledby="navbarDropdownUser">
                            <div className="card position-relative border-0">
                                <div className="card-body p-0">
                                    <div className="text-center pt-4 pb-3">
                                        {renderAvatar("avatar-xl", "80px", "20px")}
                                        <h6 className="mt-3 mb-0 text-body-emphasis">{userAvatar.UserName}</h6>
                                        <h6 className="mt-2 text-body-emphasis">{userAvatar.Email}</h6>
                                    </div>
                                </div>
                                <div className="card-footer p-0 border-0">
                                    <div className="py-2">
                                        <a className="dropdown-item px-4 py-2 d-flex align-items-center fw-bold text-dark" href="#" onClick={(e) => { e.preventDefault(); setShowChangePasswordModal(true); }}>
                                            <FontAwesomeIcon icon={faKey} className="me-3 text-body-secondary" style={{ width: '16px' }} />
                                            Change Password
                                        </a>
                                        {!isSuperAdmin && (
                                            <>
                                                <a className="dropdown-item px-4 py-2 d-flex align-items-center fw-bold text-dark" href="#" onClick={(e) => { e.preventDefault(); setShowMyPermissionsModal(true); }}>
                                                    <FontAwesomeIcon icon={faIdBadge} className="me-3 text-body-secondary" style={{ width: '16px' }} />
                                                    My Permissions
                                                </a>
                                                <a className="dropdown-item px-4 py-2 d-flex align-items-center fw-bold text-dark" href="#" onClick={(e) => { e.preventDefault(); setShowRequestPermissionModal(true); }}>
                                                    <FontAwesomeIcon icon={faHandHoldingHand} className="me-3 text-body-secondary" style={{ width: '16px' }} />
                                                    Request Access
                                                </a>
                                            </>
                                        )}
                                        <PermissionGuard require="Permissions.Header.DatabaseManagement.Access">
                                            <a className="dropdown-item px-4 py-2 d-flex align-items-center fw-bold text-dark" href="#" onClick={(e) => { e.preventDefault(); setShowDatabaseModal(true); }}>
                                                <FontAwesomeIcon icon={faDatabase} className="me-3 text-body-secondary" style={{ width: '16px' }} />
                                                Database Management
                                            </a>
                                        </PermissionGuard>
                                        <PermissionGuard require="Permissions.Header.SystemServicesTesting.Access">
                                            <a className="dropdown-item px-4 py-2 d-flex align-items-center fw-bold text-dark" href="#" onClick={(e) => { e.preventDefault(); setShowSystemTestingModal(true); }}>
                                                <FontAwesomeIcon icon={faHeartbeat} className="me-3 text-body-secondary" style={{ width: '16px' }} />
                                                System Services Testing
                                            </a>
                                        </PermissionGuard>
                                        <PermissionGuard require="Permissions.Header.SecuritySettings.Access">
                                            <a className="dropdown-item px-4 py-2 d-flex align-items-center fw-bold text-dark" href="#" onClick={(e) => { e.preventDefault(); setShowSecurityModal(true); }}>
                                                <FontAwesomeIcon icon={faShieldAlt} className="me-3 text-body-secondary" style={{ width: '16px' }} />
                                                Security Settings
                                            </a>
                                        </PermissionGuard>
                                        <PermissionGuard require="Permissions.Header.SearchSettings.Access">
                                            <a className="dropdown-item px-4 py-2 d-flex align-items-center fw-bold text-dark" href="#" onClick={(e) => { e.preventDefault(); setShowSearchModal(true); }}>
                                                <FontAwesomeIcon icon={faSearch} className="me-3 text-body-secondary" style={{ width: '16px' }} />
                                                Search Settings
                                            </a>
                                        </PermissionGuard>
                                        <hr className="dropdown-divider my-2" />
                                        <PermissionGuard require="Permissions.Header.RoleManagement.Access">
                                            <a className="dropdown-item px-4 py-2 d-flex align-items-center fw-bold text-dark" href="#" onClick={(e) => { e.preventDefault(); setShowRoleManagementModal(true); }}>
                                                <FontAwesomeIcon icon={faUserLock} className="me-3 text-body-secondary" style={{ width: '16px' }} />
                                                Role Management
                                            </a>
                                        </PermissionGuard>
                                        <PermissionGuard require="Permissions.Header.CreateAdminAccount.Access">
                                            <a className="dropdown-item px-4 py-2 d-flex align-items-center fw-bold text-dark" href="#" onClick={(e) => { e.preventDefault(); setShowCreateAdminModal(true); }}>
                                                <FontAwesomeIcon icon={faUserShield} className="me-3 text-body-secondary" style={{ width: '16px' }} />
                                                Create Admin Account
                                            </a>
                                        </PermissionGuard>
                                        <PermissionGuard require="Permissions.Header.CreateUserAccount.Access">
                                            <a className="dropdown-item px-4 py-2 d-flex align-items-center fw-bold text-dark" href="#" onClick={(e) => { e.preventDefault(); setShowCreateUserModal(true); }}>
                                                <FontAwesomeIcon icon={faUser} className="me-3 text-body-secondary" style={{ width: '16px' }} />
                                                Create User Account
                                            </a>
                                        </PermissionGuard>
                                        <hr className="dropdown-divider my-2" />
                                        <a className="dropdown-item px-4 py-2 d-flex align-items-center text-danger fw-bold" href="#" onClick={handleSignOut}>
                                            <FontAwesomeIcon icon={faSignOut} className="me-3" style={{ width: '16px' }} />
                                            Sign out
                                        </a>
                                    </div>
                                    <div className="my-2 text-center fw-bold fs-10 text-body-quaternary">
                                        <Link className="text-body-quaternary me-1" to="/home">Privacy policy</Link>
                                        •<Link className="text-body-quaternary mx-1" to='/home'>Terms</Link>
                                        •<Link className="text-body-quaternary ms-1" to='/home'>Cookies</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <SecuritySettingsModal show={showSecurityModal} onClose={() => setShowSecurityModal(false)} />
            <SearchSettingsModal show={showSearchModal} onClose={() => setShowSearchModal(false)} />
            <GlobalSearchModal show={showGlobalSearch} onClose={() => setShowGlobalSearch(false)} />
            <DatabaseManagementModal show={showDatabaseModal} onClose={() => setShowDatabaseModal(false)} />
            <SystemServicesTestingModal show={showSystemTestingModal} onClose={() => setShowSystemTestingModal(false)} />
            <RoleManagementModal show={showRoleManagementModal} onClose={() => setShowRoleManagementModal(false)} />
            <CreateAdminModal show={showCreateAdminModal} onClose={() => setShowCreateAdminModal(false)} />
            <CreateUserAccountModal show={showCreateUserModal} onClose={() => setShowCreateUserModal(false)} />
            <ViewPermissionModal 
                show={showMyPermissionsModal} 
                onClose={() => setShowMyPermissionsModal(false)} 
                user={{ 
                    id: admin?.Id || admin?.id || admin?.UserId || admin?.userId, 
                    name: userAvatar?.UserName || admin?.UserName || admin?.name, 
                    roles: admin?.Roles || admin?.roles || (admin?.Role || admin?.role ? [{ Name: admin?.Role || admin?.role }] : []) 
                }} 
            />
            <RequestPermissionModal 
                show={showRequestPermissionModal} 
                onClose={() => setShowRequestPermissionModal(false)} 
                user={{ 
                    id: admin?.Id || admin?.id || admin?.UserId || admin?.userId, 
                    name: userAvatar?.UserName || admin?.UserName || admin?.name, 
                    roles: admin?.Roles || admin?.roles || (admin?.Role || admin?.role ? [{ Name: admin?.Role || admin?.role }] : []) 
                }} 
            />
            <ChangePasswordAdminModal show={showChangePasswordModal} onClose={() => setShowChangePasswordModal(false)} />
        </nav>
    )
}

export default HeaderAdmin;